export enum PaymentIntegrationType {
  FIRSTDATA = 'FIRSTDATA',
  ORBITAL = 'CHASE_ORBITAL',
  WORLDPAY = 'WORLDPAY',
}
